import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Button from 'shared/Button';
import SeriesLineItem from './SeriesLineItem';
import moment from 'moment';
import Skeleton from 'shared/Skeleton';
import { hourMinute, weekDayMonthDayYearShort } from '@showclix-shared-intl/dateTimeFormatters';
import Translation from '@checkout-s/Translation';

export default class MenuDatePicker extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showMenu: false,
        }
    }

    render() {
        return (
            <Fragment>
                <div className="menu-datepicker__container">
                    <div className="menu-datepicker">
                        <div className="tickets__datepicker menu-datepicker__select">
                            <div onClick={this.showMenu} loading={this.props.loading} className={`input__select__fake ${this.state.showMenu ? 'active' : 'inactive'}`}>
                                <div className="input__control__fake">
                                {this.props.selectedChildEvent ?
                                    this.selectedTime()
                                    :
                                    this.getSelectText()
                                }
                                </div>
                            </div>
                        </div>
                    </div>
                    {this.state.showMenu === true &&
                        <div className="list-date-picker__modal">
                            <div className="list-date-picker__modal-inner">
                                <div className="list-date-picker__modal-header">
                                    <div className="list-date-picker__modal-header__left">
                                        <span className="list-date-picker__modal-title"><Translation>{'checkout__select_date_and_time'}</Translation></span>
                                    </div>
                                    <div className="list-date-picker__modal-header__right">
                                        <div className="list-date-picker__modal-close-button">
                                            <button
                                                onClick={this.hideMenu}
                                                className="button--clear button--close ticket__hide-overlay"
                                            >
                                                <svg width="24px" height="24px" viewBox="0 0 24 24">
                                                    <path fill="#000000" d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
                                                </svg>
                                                <span className="sr-only"><Translation>{'checkout__close'}</Translation></span>
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                {!this.props.loaded &&
                                    <Fragment>
                                        <div className="card-group">
                                            <div className="card">
                                                <Skeleton height="13px" width="166px" />
                                            </div>
                                            <div className="card">
                                                <Skeleton height="10px" width="70px" />
                                            </div>
                                            <div className="card">
                                                <Skeleton height="10px" width="100px" />
                                            </div>
                                        </div>
                                        <div className="card-group">
                                            <div className="card">
                                                <Skeleton height="13px" width="166px" />
                                            </div>
                                            <div className="card">
                                                <Skeleton height="10px" width="70px" />
                                            </div>
                                            <div className="card">
                                                <Skeleton height="10px" width="100px" />
                                            </div>
                                        </div>
                                        <div className="card-group">
                                            <div className="card">
                                                <Skeleton height="13px" width="166px" />
                                            </div>
                                            <div className="card">
                                                <Skeleton height="10px" width="70px" />
                                            </div>
                                            <div className="card">
                                                <Skeleton height="10px" width="100px" />
                                            </div>
                                        </div>
                                    </Fragment>
                                }
                                {this.renderEvents()}
                            </div>
                        </div>
                    }
                </div>
            </Fragment>
        )
    }

    getSelectText = () => {
        let text = <Translation>{'checkout__please_select_date_time'}</Translation>;

        if(this.props.selectedDay) {
            text = <Translation>{'checkout__please_select_time'}</Translation>;
        }

        return text;
    }

    renderEvents = () => {
        return Object.keys(this.props.eventTimes).map((date, i) => {
            const time = new Date(date);
            const timeString = weekDayMonthDayYearShort(this.props.locale, time);
            return <div key={i}>
                <div className="card-group">
                    {!this.props.selectedDay && <div className="card">
                        <div className="list-date-picker__card-date">
                            <time dateTime={timeString}>{timeString}</time>
                        </div>
                    </div>}
                    {this.props.eventTimes[date].map((event, j) => {
                        return <SeriesLineItem
                            key={'' + i + j}
                            time={event.time}
                            endTime={event.endTime}
                            id={event.id}
                            onClick={this.props.onEventSelected}
                            selected={this.props.selectedChildEvent === event.id}
                            eventStatus={event.eventStatus}
                            showSoldOut={this.props.showSoldOut}
                            eventInventory={+event.inventory}
                            locale={this.props.locale}
                            seriesChildAdditionalInfo={event.childEventAdditionalInfo}
                        />
                    })}
                </div>
            </div>
        });
    }

    selectedTime = () => {
        let selectedTime = '';
        let times = Object.values(this.props.eventTimes)
        let i;
        let j;

        for (const date in this.props.eventTimes) {
            for(i = 0; i < this.props.eventTimes[date].length; i++) {
                if(this.props.eventTimes[date][i].id === this.props.selectedChildEvent) {
                    const time = new Date(date);
                    const dateString = weekDayMonthDayYearShort(this.props.locale, time);
                    const eventTime = new Date(this.props.eventTimes[date][i].time);
                    const eventString = hourMinute(this.props.locale, eventTime);
                    selectedTime = dateString + ' ' +eventString;
                }
            }
        }

        return <span>{selectedTime}</span>
    }

    showMenu = () => {
        this.setState({showMenu: !this.state.showMenu});
    }

    hideMenu = () => {
        this.setState({showMenu: false});
    }
}

MenuDatePicker.propTypes = {
    eventTimes: PropTypes.object,
    loading: PropTypes.bool,
    selectedChildEvent: PropTypes.oneOfType([PropTypes.string,PropTypes.number]),
    showSoldOut: PropTypes.bool,
    onEventSelected: PropTypes.func.isRequired,
};
